import { useCallback } from 'react';

import { clearStorage } from '@utils';

import { useAppDispatch } from '@store';
import { clearBranchInfo } from '@store/branchInfo.slice';
import { clearCounterData } from '@store/counter.slice';
import { clearUser } from '@store/user.slice';

export const useClearAppData = () => {
  const dispatch = useAppDispatch();

  const clearAppData = useCallback(async () => {
    dispatch(clearBranchInfo());
    dispatch(clearUser());
    dispatch(clearCounterData());
    clearStorage();
  }, [dispatch]);

  return { clearAppData };
};
